import { render, staticRenderFns } from "./DefaultUserBox.vue?vue&type=template&id=68892290"
import script from "./DefaultUserBox.vue?vue&type=script&lang=js"
export * from "./DefaultUserBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports